import Swiper, { Pagination, Manipulation } from "swiper";
import { addToGlobalThisRet, findControls } from "@plugins";

const selectionDefaultBreakpoints = {
    406: {
        slidesPerView: 1.9,
        spaceBetween: 15,
    },
    567: {
        slidesPerView: 3,
        spaceBetween: 15,
    },
    768: {
        shortSwipes: false,
        slidesPerView: 3,
    },
    992: {
        shortSwipes: false,
        slidesPerView: 5,
        spaceBetween: 0,
    },
};

function initSelections() {
    const selections = document.querySelectorAll(".js-selection-slider-init");

    if (selections && selections.length > 0) {
        for (const selection of selections) {
            const sliderContainer = selection.querySelector(".js-selection-slider");
            const controls = findControls(selection, ".js-selection-controls");
            const link = selection.querySelector(".js-selection-link-more");

            const swiper = new Swiper(sliderContainer, {
                modules: [Pagination, Manipulation],
                slidesPerView: 1.9,
                spaceBetween: 16,
                preventClicks: false,
                pagination: {
                    el: controls.pagination,
                    type: "progressbar",
                },
                navigation: {
                    prevEl: controls.buttonPrev,
                    nextEl: controls.buttonNext,
                },
                observer: true,
                observeParents: true,
                watchOverflow: true,
                breakpoints: selectionDefaultBreakpoints,
            });

            if (link && window.mobileMedia) {
                swiper.once("reachEnd", () => {
                    swiper.appendSlide(`
                        <div class="swiper-slide slider-link-load-more selection__link-more js-selection-link-more-slide">
                            <span class="simple-link selection__link-more-btn"> 
                                Смотреть все
                            </span>
                        </div>
                    `);
                    document
                        .querySelector(".js-selection-link-more-slide")
                        .addEventListener("click", () => {
                            link.click();
                        });
                });
            }
        }
    }
}
initSelections();

// Записываем в глобальный подобъект для бэка
addToGlobalThisRet(initSelections, "initSelections");
